// Do not import LoggingService: LoggingService -> DatadogLogger -> graphUrl creates an import cycle.
import { storageManager } from 'utils/storageUtils';

export const graphBaseUrlStorage = storageManager.createOrFetchStorage<string>('graphBaseUrl');

export enum APIType {
  BASE,
  GRAPHQL,
  SUBSCRIPTION,
}

/**
 * Gets the current API url from either localStorage or the default environment
 */
export const getGraphURL = (type: APIType = APIType.BASE): string => {
  const debugUrl = (graphBaseUrlStorage.get() || process.env.REACT_APP_GRAPH_BASE || '').replace('https://', '');
  const isEnvDebugging = process.env.REACT_APP_FEATURE_ENV_DEBUGGING === 'true';

  switch (type) {
    case APIType.GRAPHQL: {
      return isEnvDebugging ? `https://${debugUrl}/graphql` : process.env.REACT_APP_GRAPH_GRAPHQL || '';
    }

    case APIType.SUBSCRIPTION: {
      return isEnvDebugging ? `wss://${debugUrl}/graphql-ws` : process.env.REACT_APP_GRAPH_SUBSCRIPTIONS || '';
    }

    default: {
      return isEnvDebugging ? `https://${debugUrl}` : process.env.REACT_APP_GRAPH_BASE || '';
    }
  }
};
